import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { Types, ConsultaCidadesUFState } from './types';
import { ReducerAction } from '../../../types';

export const INITIAL_STATE: ConsultaCidadesUFState = {
	status: 0,
	data: [],
};

export default function consultaCidadesUFReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaCidadesUFState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CIDADES_UF_REQUEST: {
				break;
			}
			case Types.CONSULTA_CIDADES_UF_SUCCESS: {
				draft.status = action.payload.status;
				const lista = toSelect(action.payload.data, 'municipio', 'codigoIBGE');
				draft.data = [...lista];
				break;
			}
			case Types.CONSULTA_CIDADES_UF_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTA_CIDADES_UF_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
